/* js/components/HalteMultitrack.svelte generated by Svelte v3.46.4 */
import {
	HtmlTag,
	SvelteComponent,
	append,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Header from './Header.svelte';
import TrackPlayer from './TrackPlayer.svelte';
import { db } from '../Db';
import { onMount } from 'svelte';
import { HalteParentType } from '../HalteParentType';
import { appRouter } from '../appRouter.js';
import CardPlayer from './CardPlayer.svelte';
import CardMeta from './CardMeta.svelte';
import HyperButton from './HyperButton.svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[12] = list[i];
	return child_ctx;
}

// (82:0) {#each cards as card}
function create_each_block(ctx) {
	let h2;
	let t0_value = /*card*/ ctx[12].media.title + "";
	let t0;
	let t1;
	let trackplayer;
	let t2;
	let cardmeta;
	let t3;
	let html_tag;
	let raw_value = /*card*/ ctx[12].html + "";
	let html_anchor;
	let current;

	trackplayer = new TrackPlayer({
			props: {
				src: /*card*/ ctx[12].media.src,
				type: /*card*/ ctx[12].media.type
			}
		});

	cardmeta = new CardMeta({ props: { card: /*card*/ ctx[12] } });

	return {
		c() {
			h2 = element("h2");
			t0 = text(t0_value);
			t1 = space();
			create_component(trackplayer.$$.fragment);
			t2 = space();
			create_component(cardmeta.$$.fragment);
			t3 = space();
			html_tag = new HtmlTag();
			html_anchor = empty();
			html_tag.a = html_anchor;
		},
		m(target, anchor) {
			insert(target, h2, anchor);
			append(h2, t0);
			insert(target, t1, anchor);
			mount_component(trackplayer, target, anchor);
			insert(target, t2, anchor);
			mount_component(cardmeta, target, anchor);
			insert(target, t3, anchor);
			html_tag.m(raw_value, target, anchor);
			insert(target, html_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*cards*/ 2) && t0_value !== (t0_value = /*card*/ ctx[12].media.title + "")) set_data(t0, t0_value);
			const trackplayer_changes = {};
			if (dirty & /*cards*/ 2) trackplayer_changes.src = /*card*/ ctx[12].media.src;
			if (dirty & /*cards*/ 2) trackplayer_changes.type = /*card*/ ctx[12].media.type;
			trackplayer.$set(trackplayer_changes);
			const cardmeta_changes = {};
			if (dirty & /*cards*/ 2) cardmeta_changes.card = /*card*/ ctx[12];
			cardmeta.$set(cardmeta_changes);
			if ((!current || dirty & /*cards*/ 2) && raw_value !== (raw_value = /*card*/ ctx[12].html + "")) html_tag.p(raw_value);
		},
		i(local) {
			if (current) return;
			transition_in(trackplayer.$$.fragment, local);
			transition_in(cardmeta.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(trackplayer.$$.fragment, local);
			transition_out(cardmeta.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h2);
			if (detaching) detach(t1);
			destroy_component(trackplayer, detaching);
			if (detaching) detach(t2);
			destroy_component(cardmeta, detaching);
			if (detaching) detach(t3);
			if (detaching) detach(html_anchor);
			if (detaching) html_tag.d();
		}
	};
}

// (90:0) <HyperButton class="button section-map" on:click={gotoMap} >
function create_default_slot(ctx) {
	let t;

	return {
		c() {
			t = text("Poursuivre la visite");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let header;
	let t0;
	let br0;
	let t1;
	let br1;
	let t2;
	let br2;
	let t3;
	let br3;
	let t4;
	let h1;
	let t5_value = /*halte*/ ctx[0].title + "";
	let t5;
	let t6;
	let html_tag;
	let t7;
	let t8;
	let hyperbutton;
	let t9;
	let br4;
	let t10;
	let br5;
	let t11;
	let br6;
	let current;
	header = new Header({ props: { title: "Halte" } });
	let each_value = /*cards*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	hyperbutton = new HyperButton({
			props: {
				class: "button section-map",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	hyperbutton.$on("click", /*gotoMap*/ ctx[3]);

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			br0 = element("br");
			t1 = space();
			br1 = element("br");
			t2 = space();
			br2 = element("br");
			t3 = space();
			br3 = element("br");
			t4 = space();
			h1 = element("h1");
			t5 = text(t5_value);
			t6 = space();
			html_tag = new HtmlTag();
			t7 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t8 = space();
			create_component(hyperbutton.$$.fragment);
			t9 = space();
			br4 = element("br");
			t10 = space();
			br5 = element("br");
			t11 = space();
			br6 = element("br");
			html_tag.a = t7;
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			insert(target, br0, anchor);
			insert(target, t1, anchor);
			insert(target, br1, anchor);
			insert(target, t2, anchor);
			insert(target, br2, anchor);
			insert(target, t3, anchor);
			insert(target, br3, anchor);
			insert(target, t4, anchor);
			insert(target, h1, anchor);
			append(h1, t5);
			insert(target, t6, anchor);
			html_tag.m(/*html*/ ctx[2], target, anchor);
			insert(target, t7, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, t8, anchor);
			mount_component(hyperbutton, target, anchor);
			insert(target, t9, anchor);
			insert(target, br4, anchor);
			insert(target, t10, anchor);
			insert(target, br5, anchor);
			insert(target, t11, anchor);
			insert(target, br6, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*halte*/ 1) && t5_value !== (t5_value = /*halte*/ ctx[0].title + "")) set_data(t5, t5_value);
			if (!current || dirty & /*html*/ 4) html_tag.p(/*html*/ ctx[2]);

			if (dirty & /*cards*/ 2) {
				each_value = /*cards*/ ctx[1];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(t8.parentNode, t8);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			const hyperbutton_changes = {};

			if (dirty & /*$$scope*/ 32768) {
				hyperbutton_changes.$$scope = { dirty, ctx };
			}

			hyperbutton.$set(hyperbutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(hyperbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(hyperbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(br0);
			if (detaching) detach(t1);
			if (detaching) detach(br1);
			if (detaching) detach(t2);
			if (detaching) detach(br2);
			if (detaching) detach(t3);
			if (detaching) detach(br3);
			if (detaching) detach(t4);
			if (detaching) detach(h1);
			if (detaching) detach(t6);
			if (detaching) html_tag.d();
			if (detaching) detach(t7);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t8);
			destroy_component(hyperbutton, detaching);
			if (detaching) detach(t9);
			if (detaching) detach(br4);
			if (detaching) detach(t10);
			if (detaching) detach(br5);
			if (detaching) detach(t11);
			if (detaching) detach(br6);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { halte } = $$props;
	let { nextHalte } = $$props;
	let hasBonus;
	let hasBiblio;
	let bonusContent;
	let biblioContent;
	let cards = [];
	let html = null; // html content of the halte
	let currentCardIndex = 0;

	onMount(async () => {
		const trackHalte = await db.getHalteContentFor(halte.parentSlug, halte.slug, HalteParentType.constellation);
		$$invalidate(1, cards = trackHalte.cards);
		$$invalidate(2, html = trackHalte.html);
		console.log("cards", cards);
		hasBonus = !!halte.contentMap.bonus_url;
		hasBiblio = !!halte.contentMap.bibliography_url;

		if (hasBonus) {
			bonusContent = await db.getBonusContentFor(halte.parentSlug, halte.slug);
		}

		if (hasBiblio) {
			biblioContent = await db.getBiblioContentFor(halte.parentSlug, halte.slug);
		}
	});

	function onNext() {
		currentCardIndex = (currentCardIndex + 1) % cards.length;
	}

	function onPrevious() {
		currentCardIndex -= 1;

		if (currentCardIndex < 0) {
			currentCardIndex = cards.length - 1;
		}
	}

	function gotoMap() {
		appRouter.show(`/constellation/${halte.parentSlug}/carte`);
	}

	$$self.$$set = $$props => {
		if ('halte' in $$props) $$invalidate(0, halte = $$props.halte);
		if ('nextHalte' in $$props) $$invalidate(4, nextHalte = $$props.nextHalte);
	};

	return [halte, cards, html, gotoMap, nextHalte];
}

class HalteMultitrack extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { halte: 0, nextHalte: 4 });
	}
}

export default HalteMultitrack;